import React, { useRef, useEffect, useState } from "react";
import "./App.css";
import NavBar from "./components/NavBar";
import { Text, Flex, Container, Heading, Button } from "@radix-ui/themes";
import { TypeAnimation } from "react-type-animation";
import Footer from "./components/Footer";
import AudioPlayer from "./components/AudioPlayer";
// import Pricing from "./components/Payments";
import MobileView from "./components/MobileView/MobileView";

const MyApp = () => {
  const pricingRef = useRef(null);
  const topRef = useRef(null);

  const scrollToPricing = () => {
    pricingRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const scrollToTop = () => {
    topRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768); // Set the breakpoint at 768px
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Call it initially to set the state

    return () => window.removeEventListener("resize", handleResize); // Clean up on unmount
  }, []);

  return (
    <>
      {isSmallScreen ? (
        <div>
          <MobileView />
        </div>
      ) : (
        <div>
          <NavBar scrollToPricing={scrollToPricing} scrollToTop={scrollToTop} />

          <div ref={topRef}>
            <Container align="center" maxWidth="1920px">
              <div style={{ display: "flex" }}>
                <div style={{ flex: 45, backgroundColor: "black" }}>
                  <Flex
                    direction="column"
                    gap="5"
                    style={{ position: "relative", top: "8rem", left: "10rem" }}
                  >
                    <div>
                      <Heading size="9">AI POWERED</Heading>
                      <Heading size="9">AUDIO</Heading>
                      <Heading size="9">LEARNING</Heading>
                      <Heading size="9">PLATFORM</Heading>
                    </div>

                    <div style={{ maxWidth: "300px" }}>
                      <Text variant="body">
                        Built to make learning accessible and effortless,{" "}
                        <span style={{ color: "#009951" }}>Tellos AI</span>{" "}
                        transforms any topic into engaging audio content with
                        AI.
                      </Text>
                    </div>

                    <Button
                      size="2"
                      variant="solid"
                      color="green"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#009951",
                        width: "200px",
                      }}
                      onClick={() =>
                        (window.location.href = "https://client.iamtellos.com")
                      }
                    >
                      Start learning - For Free
                    </Button>
                  </Flex>
                </div>

                <div style={{ flex: 55 }}>
                  <img
                    src="/assets/graphics/SVG/landingPageImage.svg"
                    alt="landing page"
                    style={{
                      width: "100%",
                      height: "auto",
                      backgroundColor: "black",
                    }}
                  />
                </div>
              </div>
            </Container>
          </div>

          <div style={{ marginTop: "75px" }}>
            <Container align="center" maxWidth="1920px">
              <div style={{ display: "flex" }}>
                <div style={{ flex: 50 }}>
                  <img
                    src="/assets/graphics/SVG/girlHoldingPhone.svg"
                    alt="girl holding phone"
                    style={{
                      width: "100%",
                      height: "auto",
                      backgroundColor: "black",
                    }}
                  />
                </div>

                <div style={{ flex: 50, backgroundColor: "black" }}>
                  <Flex
                    direction="column"
                    gap="9"
                    style={{
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <div>
                      <Flex direction="column" gap="3">
                        <Heading size="8" style={{ color: "#009951" }}>
                          Create
                        </Heading>
                        <Text variant="body">
                          Enter a topic or phrase that sparks your curiosity.
                        </Text>
                      </Flex>

                      <br></br>
                      <TypeAnimation
                        sequence={[
                          "Summary of The Fabric of Reality.",
                          5000,
                          "Explain Allegory of the cave.",
                          5000,
                        ]}
                        speed={50}
                        style={{ fontSize: "40px", fontWeight: "lighter" }}
                        repeat={Infinity}
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Heading size="8" style={{ color: "#009951" }}>
                        Listen
                      </Heading>

                      <AudioPlayer />
                    </div>

                    <div>
                      <Flex direction="column" gap="3">
                        <Heading size="8" style={{ color: "#009951" }}>
                          Learn
                        </Heading>
                        <Text variant="body">Expand your knowledge.</Text>
                      </Flex>
                    </div>
                  </Flex>
                </div>
              </div>
            </Container>
          </div>

          <div style={{ marginTop: "75px" }}>
            <Container align="center" maxWidth="1920px">
              <div style={{ display: "flex" }}>
                <div style={{ flex: 40, backgroundColor: "black" }}>
                  <Flex
                    direction="column"
                    style={{
                      position: "relative",
                      top: "50rem",
                      left: "10rem",
                    }}
                  >
                    <Heading size="8">Create a curated</Heading>
                    <Heading size="8">digital library</Heading>
                    <Heading size="8">with Tellos AI.</Heading>
                  </Flex>
                </div>

                <div style={{ flex: 60 }}>
                  <img
                    src="/assets/graphics/SVG/digitalLibrary.svg"
                    alt="digital library"
                    style={{
                      width: "100%",
                      height: "auto",
                      backgroundColor: "black",
                    }}
                  />
                </div>
              </div>
            </Container>
          </div>

          {/* <Pricing ref={pricingRef} /> */}

          <Footer ref={pricingRef} />
        </div>
      )}
    </>
  );
};

export default MyApp;
